const PLATFORM_HOSTS = [
  "localhost",
  "127.0.0.1",
  "lovable.app",
  "lovable.dev",
  "memberos.app",
  "memberos.co",
  "memberos.lovable.app",
  "vercel.app",
];

export const normalizeHostname = (hostname: string) =>
  hostname.trim().toLowerCase().replace(/\.$/, "").replace(/:\d+$/, "");

export const isPlatformHost = (hostname: string): boolean => {
  const normalized = normalizeHostname(hostname);

  return PLATFORM_HOSTS.some((host) => normalized === host || normalized.endsWith(`.${host}`));
};
